import { Component, Input } from '@angular/core';

/**
 * `<app-submission-session-display>` — apresentação READ-ONLY da linha
 * "Sessão: {título} - {subtítulo} ({sala}, {data})" com o dialog de
 * timezone. Passo 3 da migração pra `<app-submission-export-view>`.
 *
 * Não tem modo edição (sessão é gerida pelo chair fora do paper-info).
 * Wrapper `<div class="section" session-section remove-from-export>`
 * permanece no paper-info (padding lateral scoped + marcador de export).
 */
@Component({
  selector: 'app-submission-session-display',
  templateUrl: './submission-session-display.component.html',
  styleUrls: ['./submission-session-display.component.scss'],
})
export class SubmissionSessionDisplayComponent {
  /** Objeto de sessão. `*ngIf="session?.start"` no template evita render
   *  quando não há sessão agendada (mesmo comportamento do paper-info). */
  @Input() session: { title?: string; subtitle?: string; room?: string; start?: Date | string } | null | undefined;
  /** Timezone do evento pra o `<app-dialog-timezone>` exibir o "?" com
   *  conversão. Vem do `submission.event.eventInfo.timeZone`. */
  @Input() eventTimeZone: string | null | undefined;
}
